import { buildAppGridItems, iconSvg } from '../../data/appsGrid';
import Reveal from '../ui/Reveal';

const items = buildAppGridItems();

export default function AppsGrid() {
  return (
    <section className="sect" id="s-grid" style={{ paddingTop: '24px' }}>
      <div className="container">
        <Reveal>
          <h2 className="sect-h2">
            All your teams, tools, and
            <br />
            patterns <span className="dim">in TeamGrid</span>
          </h2>
          <p className="sect-sub">
            Those categories above? Here’s everything inside them — one brain, no seams.
          </p>
        </Reveal>
      </div>
      <div className="container-wide">
        <div className="appgrid-wrap">
          <div className="appgrid" id="appgrid">
            {items.map((item, i) =>
              item.type === 'big' ? (
                <div className="bigtile" key={`big-${item.n}-${i}`}>
                  <div className="shot" dangerouslySetInnerHTML={{ __html: item.shot }} />
                  <div className="bt-label">
                    <span
                      className="bic"
                      style={{ background: item.c }}
                      dangerouslySetInnerHTML={{ __html: item.ic }}
                    />
                    {item.n}
                  </div>
                </div>
              ) : (
                <div className={`cell${item.dim ? ' dimc' : ''}`} key={`cell-${item.label}-${i}`}>
                  <span dangerouslySetInnerHTML={{ __html: iconSvg(item.color, item.glyph) }} />
                  <span className="cl">{item.label}</span>
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
